// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__nfN8Y","center":"Footer_center__tSFJW"};